import { render } from "./SetupReminderToggle.vue?vue&type=template&id=438501f6&ts=true"
import script from "./SetupReminderToggle.vue?vue&type=script&lang=ts"
export * from "./SetupReminderToggle.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
